export default __webpack_public_path__ + "static/media/List-documentation.53df5c86.md";